import Contact from '../components/Form/Contact';

export default function ContactForm() {
    document.title = "Contact - Suplib";

    return (
        <>
            <Contact />
        </>
    )
}